import type { RoomOccupancy } from '@/types/SearchBar.ts';
import { $t } from '@/composables/translations/useTranslate.ts';

/**
 * Format a RoomOccupancy into a human-readable pax summary, totalled across all
 * rooms — e.g. "2 adults, 1 child". Matches the search bar wording exactly.
 * Returns an empty string when there are no persons.
 */
export function formatOccupancySummary(occupancy: RoomOccupancy | undefined): string {
  const rooms = occupancy?.rooms ?? [];

  const adults = rooms.reduce(
    (sum, room) => sum + room.persons.filter((p) => p.type === 'adult').length,
    0
  );
  const children = rooms.reduce(
    (sum, room) => sum + room.persons.filter((p) => p.type === 'child').length,
    0
  );

  if (adults === 0 && children === 0) return '';

  let label = `${adults} ${
    adults === 1 ? $t('ibe.common.adult', 'adult') : $t('ibe.common.adults', 'adults')
  }`;
  if (children > 0) {
    label += `, ${children} ${
      children === 1 ? $t('ibe.common.child', 'child') : $t('ibe.common.children', 'children')
    }`;
  }
  return label;
}
